<template>
  <div class="login-form">
    <section class="hero is-light is-bold">
      <div class="hero-body">
        <div class="container">
          <p class="title">
            <vue-typed-js
              :strings="['KYC Forms', 'Know Your Client Forms' ,'Know Your Client']"
              :typeSpeed="100"
              :backSpeed="100"
              :backDelay="150"
            >
              <h3><span class="typing"></span></h3>
            </vue-typed-js>
          </p>
        </div>
      </div>
    </section>

    <section class="hero">
      <div class="hero-body">
        <div class="container is-fluid login-box">
          <section>
            <b-field label="Email" position="is-centered">
              <b-input type="email"
                name="email"
                v-focus
                v-model="email"
                @keyup.native.enter="loginUser"
              />
            </b-field>
            <b-field label="Password" position="is-centered" @keyup.enter="loginUser">
              <b-input type="password"
                name="password"
                password-reveal
                v-model="password"
                @keyup.native.enter="loginUser"/>
            </b-field>
            <div class="reset-password">
              <router-link to="reset-password">Forgot your password?</router-link>
            </div>
            <b-field position="is-centered">
              <button class="button is-primary is-outlined" type="submit" @click="loginUser">Login</button>
            </b-field>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'LoginForm',
  data () {
    return {
      email: null,
      password: null
    }
  },
  created () {
    this.$store.dispatch('setIsLoading', { isLoading: false })
  },
  mounted () {
    if (this.$auth.check()) {
      this.$router.replace({name: 'main'})
    }
  },
  methods: {
    loginUser (e) {
      if (this.email && this.password) {
        const credentials = {
          username: this.email,
          password: this.password
        }

        const redirect = this.$auth.redirect()

        this.$auth.login({
          data: credentials,
          rememberMe: true,
          redirect: redirect ? redirect.from : { name: 'main' }
        })
          .then(response => {
            this.$toast.open({
              duration: 500,
              message: 'Logged in',
              type: 'is-info'
            })
          })
          .catch(error => {
            console.log('error ' + error)
            this.$toast.open({
              duration: 5000,
              message: 'Something went wrong. Please check your email and password or try later.',
              type: 'is-danger'
            })
          })
      }
    }
  }
}
</script>

<style scoped>
.login-box {
  margin: auto;
  max-width: 400px;
}

.reset-password {
  font-size: 0.9em;
  text-align: right;
}
</style>
